import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Channel } from '../dto';
import { AbstractService } from './abstractservice';
import { AuthService } from './auth.service';
import { FeatureFlagService } from './feature-flag.service';
import { InboxService } from './inbox.service';


@Injectable({
    providedIn: 'root'
})
export class ChatbarService extends AbstractService {

    constructor(auth: AuthService, featureFlagService: FeatureFlagService, private inboxService: InboxService) {
        super(auth, featureFlagService);
    }

    private readonly activeChannelsState: WritableSignal<Channel[]> = signal<Channel[]>([]);
    public readonly activeChannelsSignal: Signal<Channel[]> = this.activeChannelsState.asReadonly();
    private maxActiveChannels = 5;

    public OpenChannel(channel: Channel) {
        const activeChannels = [...this.activeChannelsState()];

        //make sure its not already open
        const openedChannelIndex = activeChannels.findIndex(ch => ch.Id === channel.Id);
        if (openedChannelIndex >= 0) {
            if (openedChannelIndex === 0) { //activating a channel already at the prime position does nothing

                return; //(todo "active" might mean on a hotbar but not opened. Not currently!)

            } //but activating a channel at the back of the pack should highlight it by moving it up!
            const openedChannel = activeChannels.splice(openedChannelIndex, 1)[0];
            activeChannels.unshift(openedChannel);
        } else {
            activeChannels.unshift(channel); //might need to fetch this from the inbox svc
            while (activeChannels.length > this.maxActiveChannels) { activeChannels.pop(); }
        }
        this.activeChannelsState.set(activeChannels);
    }

    public CloseChannel(channel: Channel) {
        const activeChannels = [...this.activeChannelsState()];

        //make sure its actually open
        const openedChannelIndex = activeChannels.findIndex(ch => ch.Id === channel.Id);
        if (openedChannelIndex >= 0) {
            activeChannels.splice(openedChannelIndex, 1);
            this.activeChannelsState.set(activeChannels);
        }

    }

    public FindOrCreateAndOpenChat(username: string) {
        const privateMessageChannel = this.inboxService.findPrivateChat(username) ?? this.findOpenTempChannel(username);
        if (privateMessageChannel) {
            if (privateMessageChannel.Id >= 0) { this.OpenChannel(privateMessageChannel); }
        } else {
            const newChannel = new Channel(null, null);
            newChannel.Id = Math.round(Math.random() * -100000); //negative is invalid, use huge negative range as a temporary ID
            newChannel.Name = `${this.authService.authenticatedUser$.getValue().Username}, ${username}`;
            newChannel.Usernames = [this.authService.authenticatedUser$.getValue().Username, username];
            this.OpenChannel(newChannel);
        }
    }

    private findOpenTempChannel(username: string) {
        const activeChannels = this.activeChannelsState().filter(ch => ch.Usernames.length === 2);
        const tempPrivateMessage = activeChannels.find(ch => ch.Usernames.includes(username));
        return tempPrivateMessage;

    }

}
